import Model, { attr } from '@ember-data/model';

export default class DayConfig extends Model {
  @attr('string') value;
  @attr('boolean', { defaultValue: true }) isChecked;
}
